// extracted by mini-css-extract-plugin
export default {"item":"BotsItem_item__PHTC1","inDev":"BotsItem_inDev__zTzW9","icon":"BotsItem_icon__d+pXl","name":"BotsItem_name__GoI+S","dev":"BotsItem_dev__N2INY"};